<template>
  <div class="page-content">
    <page-breadcrumb title="Groups" class="mb-2" />

    <data-create-popup title="Create Group"
      :schema="create_schema" :default-data="{name: '', description: null}"
      :create-data-fn="createItem" @create="$refs.group_list.getList()"
    />
    <data-table-ssr id="group_list" ref="group_list"
      :columns="fields" :get-list-fn="getList"
      :to-edit-fn="toEditPage"
    />
  </div>
</template>

<script>
import service from '../service_group'
import { OVERLAP_TYPE_OPTIONS } from '../constant';

const create_schema = [
  {
    cols: 12,
    fields: [
      { label: 'Name', field: 'name', input_type: 'text', validate: { required: true } },
      { label: 'Description', field: 'description', input_type: 'textarea' },
      { label: 'Overlap Type', field: 'overlap_type', input_type: 'select', options: OVERLAP_TYPE_OPTIONS },
    ]
  }
];

const fields = [
  { label: 'Name', field: 'name' },
  { label: 'Description', field: 'description' },
  { label: 'Overlap Type', field: 'overlap_type', input_type: 'select', options: OVERLAP_TYPE_OPTIONS },
  { label: 'Created At', field: 'createdAt', input_type: 'datetime' },
];

export default {
  data(){
    return{
      create_schema,
      fields,
      total: 0,
    }
  },
  methods:{
    async createItem(data) {
      let new_item = await service.create({ ...data });
      return new_item;
    },
    async getList({ limit, page, query, searchTerm }) {
      let response = await service.getList({
        query: JSON.stringify({ ...query }),
        page, limit
      });
      let list = [], total = 0;
      if (response.data.type === "DATA") {
        list = response.data.data.list;
        total = response.data.data.total;
        this.total = total;
      }
      return { list, total };
    },
    toEditPage({ _id }) {
      this.$router.push({ name: 'noti-group-detail', params: { id: _id } });
    },
  }
}
</script>
